import { AccessTokenRevokeError } from 'service/api-service';

export const fromApi = async promise => {
  try {
    const value = await promise;
    if (value instanceof Error) throw value;
    return [null, value];
  } catch (error) {
    console.log(error);
    return [error];
  }
};

export const isAccessTokenError = err => {
  return err instanceof AccessTokenRevokeError;
};
